import {Windows95Window} from "../Windows95Window";
import {Container, Graphics, NineSlicePlane, Sprite, Text, TextStyle, Texture} from "pixi.js";
import { GAME_FONT, GAME_FONT_BOLD, GAME_FONT_ITALIC } from "../../Constants/Constants";
import {tsthreeConfig} from "../../../config/tsthreeConfig";
import {TWebsiteContentID} from "../../Types/TWebsiteContentID";
import {TextStyleSet} from "pixi-tagged-text/dist/types";
import TaggedText from "pixi-tagged-text";
import {SEARCH_HOMEPAGE, SpecialPageTypes, WebsiteContents} from "../../Data/WebsiteContents";
import {buttonify} from "../../../engine/HelperFunctions/buttonify";
import {SearchbarPrefab} from "../SearchbarPrefab";
import {uppercaseFirstLettersInString} from "../../../engine/HelperFunctions/uppercaseFirstLettersInString";
import {ScrollBar} from "../ScrollBar";
import {HospitalIDMapper} from "../../Data/HospitalIDMapper";
import {TDiagId, TExamId, TSympId} from "../../Types/SharedTypes";
import { IWindowState } from "../../Types/IWindowState";
import { FileEditHelpBar } from "../FileEditHelpBar";
import { MailCore } from "../../Logic/MailCore";
import { GAME_DEBUG_MODE } from "../../../engine/Constants/Constants";
import { bringToFront } from "../../../engine/HelperFunctions/bringToFront";
import { PlayerDataSingleton } from "../../Logic/PlayerDataSingleton";
import { GameObject } from "../../../engine/GameObject";
import { TutorialStageComponent } from "../../Components/TutorialStageComponent";
import { ShowBluescreen } from "../../Logic/ShowBluescreen";

const taggedTextStyleMap: TextStyleSet = {
    "default": {
        fontFamily: "Times New Roman",
        fill: 0x000000,
        fontSize: 16,
        align: "center",
        wordWrapWidth: tsthreeConfig.width - 50,
        wordWrap: true,
    },
    "title": {
        fontSize: 20,
        // fontWeight: "bold",
        fontFamily: GAME_FONT_BOLD,
    },
    "i": {
        fontStyle: "italic",
        // fontFamily: GAME_FONT_ITALIC,
    },
    "b": {
        fontWeight: "bold",
        // fontFamily: GAME_FONT_BOLD,
    },
    "hyperlink": {
        fill: 0x0000ff,
        textDecoration: "underline"
    },
    "drugle": {},
};

export class Win95InternetExplorerWindow extends Windows95Window {

    private websiteContentID: TWebsiteContentID = "blank";

    private isChangingPage: boolean = false;
    // private urlText: Text;
    private urlSearchBar: SearchbarPrefab;
    private mainContentsText: TaggedText;
    private mainContentsContainer: GameObject;
    private mainContentsBg: NineSlicePlane;
    private scrollBar: ScrollBar;

    private urlBarText: Text;

    private static searchBarPrefabSingleton: SearchbarPrefab;

    private breadcrumbIndex: number = -1;
    private breadcrumbTrail: TWebsiteContentID[] = [];

    private initializeImageTags(): void {
        // taggedTextStyleMap[] = {};
    }

    public set hasContext(val: boolean) {
        this._hasContext = val;
        if(Win95InternetExplorerWindow.searchBarPrefabSingleton) {
            Win95InternetExplorerWindow.searchBarPrefabSingleton.acceptingInput = val;
        }
    }

    public changePage(contentId: TWebsiteContentID, _skipBreadcrumbUpdate: boolean = false): void {
        if(this.isChangingPage) return;
        this.isChangingPage = true;

        if(!_skipBreadcrumbUpdate) {
            (this.breadcrumbTrail = this.breadcrumbTrail.slice(0, this.breadcrumbIndex + 1)).push(contentId);
            this.breadcrumbIndex++;
        }
        document.body.style.cursor = "wait";
        this.urlBarText.text = "";

        if(
            Win95InternetExplorerWindow.searchBarPrefabSingleton &&
            Win95InternetExplorerWindow.searchBarPrefabSingleton.parent
        ) {
            Win95InternetExplorerWindow.searchBarPrefabSingleton.hide();
        }

        setTimeout((e) => {
            if(
                (
                    contentId.indexOf("http") !== 0 && !WebsiteContents[contentId]
                )
            ) {
                this.websiteContentID = `http://www.drugle.com/${contentId}`;
            } else {
                this.websiteContentID = contentId;
                if(
                    WebsiteContents[contentId] &&
                    !SearchbarPrefab.getMinisearchCache("urls").has(this.websiteContentID)
                ) {
                    PlayerDataSingleton.addKnownUrl(this.websiteContentID);
                    SearchbarPrefab.getMinisearchCache("urls").addAll(
                        SearchbarPrefab.buildBasicMinisearchObject(
                            [this.websiteContentID]
                        )
                    );
                }
            }

            this.mainContentsText.removeAllListeners();
            if(
                !WebsiteContents[this.websiteContentID] &&
                this.websiteContentID[this.websiteContentID.length - 1] === "/"
            ) {
                this.websiteContentID =
                    this.websiteContentID.substring(0, this.websiteContentID.length - 1);
            }
            this.urlSearchBar.currentText = this.websiteContentID;
            this.mainContentsText.position.set(
                this.mainContentsText.position.x,
                0
            );

            const urlSplit = this.websiteContentID.split("/");
            const type: SpecialPageTypes =
                urlSplit.length >= 2 ? urlSplit[urlSplit.length-2] as SpecialPageTypes : null;
            const id = urlSplit[urlSplit.length-1];
            const contents = WebsiteContents[this.websiteContentID];

            if(!contents) {
                // const splitStr = this.websiteContentID.split("/");
                const isSearchPageResultPage = this.websiteContentID.indexOf(`${SEARCH_HOMEPAGE}/search`) === 0;
                if(isSearchPageResultPage) {
                    const params = this.websiteContentID.split("?")[1].split("&").map((e) => {
                        return e.replace("+", " ");
                    });
                    const searchQuery =
                        params.find((e) => e.indexOf("query=") === 0).split("=")[1]
                            .replace(/\+/g, " ");
                    const results = SearchbarPrefab.getMinisearchCache().search(
                        searchQuery,
                        {
                            fuzzy: Win95InternetExplorerWindow.searchBarPrefabSingleton["_fuzzy"],
                            prefix: Win95InternetExplorerWindow.searchBarPrefabSingleton["_prefix"],
                            filter: Win95InternetExplorerWindow.searchBarPrefabSingleton["_searchFilterFunction"]
                        }
                    );
                    let str = `\nSearch results for: ${searchQuery}\n\n`;

                    let counter: number = 0;
                    results.forEach((e, i) => {
                        if(i > 20) return;
                        counter++;
                        str += `<hyperlink url="../${
                            e.type
                        }/${e.id}">${e.name} - ${uppercaseFirstLettersInString(e.type)}</hyperlink>\n`;
                    });

                    if(results.length !== counter) {
                        str += `... and ${results.length - counter} more results\n`;
                    }

                    this.mainContentsText.text = `
${str}
`;
                    this.updateHyperlinksInText(this.mainContentsText);
                } else {
                    let listStr: string = "";

                    switch(type) {
                        case SpecialPageTypes.Symptoms:
                            const mostCommonExams: Record<TExamId, TDiagId[]> = {};
                            const relevantDiagnoses = HospitalIDMapper.getString("symptomsToDiagnoses", id)
                                .map((e: TDiagId) => ({
                                    id: e,
                                    str: HospitalIDMapper.idToStringObject[e]
                                }))
                                .filter((e) =>
                                    Boolean(e.str)
                                )
                                .sort((a,b) => a.str.localeCompare(b.str))
                                .map((e) => {
                                    HospitalIDMapper.getString(
                                        "diagnosisToExaminations",
                                        e.id
                                    ).forEach((examId: TExamId) => {
                                        if(!mostCommonExams[examId])
                                            mostCommonExams[examId] = [];
                                        mostCommonExams[examId].push(e.id);
                                    });
                                    return e;
                                });
                            const mostCommonExamsKeys = Object.keys(mostCommonExams);
                            let mostCommonExamDiagList: string[] = mostCommonExamsKeys.length !== 0 ?
                                mostCommonExams[
                                    mostCommonExamsKeys
                                        .reduce(function(prev, current) {
                                            return (
                                                mostCommonExams[prev].length > mostCommonExams[current].length
                                            ) ? prev : current;
                                        })
                                ] : [];
                            if(mostCommonExamDiagList.length <= 1) mostCommonExamDiagList = [];

                            relevantDiagnoses.forEach((e) => {
                                const addBold = mostCommonExamDiagList.findIndex((d) => d == e.id) !== -1;
                                listStr += `${addBold ? "<b>" : ""}<hyperlink url="../../diagnoses/${
                                    e.id
                                }">${e.str}</hyperlink>${addBold ? "</b>" : ""}\n`;
                            });

                            let symptomToExaminationsList = "";
                            // const arrLen = HospitalIDMapper.getString("symptomsToExaminations", id).length;
                            HospitalIDMapper.getString("symptomsToExaminations", id)
                                .map((e) => ({
                                    id: e,
                                    str: HospitalIDMapper.idToStringObject[e]
                                }))
                                .filter((e) => Boolean(e.str))

                                // Inactive hack to remove interview from every fuckin symptom
                                // .filter((e) =>
                                //     arrLen <= 1 ? true : e.str !== "Interview"
                                // )

                                .sort((a,b) => a.str.localeCompare(b.str))
                                .forEach((e) => {
                                    if(e.str) {
                                        symptomToExaminationsList += `<hyperlink url="../../exams/${
                                            e.id
                                        }">${e.str}</hyperlink>\n`;
                                    }
                                });
                            if(!symptomToExaminationsList) {
                                symptomToExaminationsList = "n/a";
                            }

                            let symptomToTreatmentList = "";
                            HospitalIDMapper.getString("symptomsToTreatments", id)
                                .map((e) => ({
                                    id: e,
                                    str: HospitalIDMapper.idToStringObject[e]
                                }))
                                .filter((e) => Boolean(e.str))
                                .sort((a,b) => a.str.localeCompare(b.str))
                                .forEach((e) => {
                                    if(e.str) {
                                        symptomToTreatmentList += `<hyperlink url="../../treatments/${
                                            e.id
                                        }">${e.str}</hyperlink>\n`;
                                    }
                                });

                            if(!symptomToTreatmentList) {
                                symptomToTreatmentList = "n/a";
                            }
                            this.mainContentsText.text = `
<title>${uppercaseFirstLettersInString(HospitalIDMapper.idToStringObject[id])}</title>
<i>Symptom</i>
${HospitalIDMapper.idToStringObject[`${id}-DESC`]}

Treated with:
${symptomToTreatmentList}

Identified by:
${symptomToExaminationsList}

Presents in:
${listStr}
\n\n\n\n    `;
                            break;
                        case SpecialPageTypes.Diagnoses:
                            const mostCommonSymptomTreatments: Record<TExamId, TSympId[]> = {};
                            const relevantSymptoms = (HospitalIDMapper.getString("diagnosesToSymptoms", id) || [""])
                                .map((e: TSympId) => ({
                                    id: e,
                                    str: HospitalIDMapper.idToStringObject[e]
                                }))
                                .filter((e) => Boolean(e.str) && e.str !== "Interview")
                                .sort((a,b) => a.str.localeCompare(b.str))
                                .map((e) => {
                                    HospitalIDMapper.getString(
                                        "symptomsToTreatments",
                                        e.id
                                    ).forEach((examId: TExamId) => {
                                        if(!mostCommonSymptomTreatments[examId])
                                            mostCommonSymptomTreatments[examId] = [];
                                        if(HospitalIDMapper.idToStringObject[examId] !== "Interview")
                                            mostCommonSymptomTreatments[examId].push(e.id);
                                    });
                                    return e;
                                });
                            const mostCommonExamSymPair = mostCommonSymptomTreatments[
                                Object.keys(mostCommonSymptomTreatments).length === 0 ? undefined :
                                    Object.keys(mostCommonSymptomTreatments).reduce(function(prev, current) {
                                        return (
                                            mostCommonSymptomTreatments[prev].length > mostCommonSymptomTreatments[current].length
                                        ) ? prev : current;
                                    })
                                ];
                            // console.log(
                            //     Object.keys(mostCommonSymptomExams)
                            //         .map((e) => mostCommonSymptomExams[e].map((e) => HospitalIDMapper.idToStringObject[e]))
                            // );
                            // console.log(
                            //     Object.keys(mostCommonSymptomExams).map((e) => HospitalIDMapper.idToStringObject[e])
                            // );

                            relevantSymptoms
                                .forEach((e) => {
                                        // listStr += `<hyperlink url="../../symptoms/${
                                        //     e.id.replace(/=/g, "@@@")
                                        // }">${e.str}</hyperlink>\n`;
                                    const addBold = mostCommonExamSymPair.findIndex((d) => d == e.id) !== -1;
                                    listStr += `${addBold ? "<b>" : ""}<hyperlink url="../../symptoms/${
                                        e.id
                                    }">${e.str}</hyperlink>${addBold ? "</b>" : ""}\n`;
                                });

                            let diagnosisToExamList = "";
                            HospitalIDMapper.getString("diagnosisToExaminations", id)
                                .map((e) => ({
                                    id: e,
                                    str: HospitalIDMapper.idToStringObject[e]
                                }))
                                .filter((e) => Boolean(e.str))
                                .sort((a,b) => a.str.localeCompare(b.str))
                                .forEach((e) => {
                                    if(e.str) {
                                        diagnosisToExamList += `<hyperlink url="../../exams/${
                                            e.id
                                        }">${e.str}</hyperlink>\n`;
                                    }
                                });

                            this.mainContentsText.text = `
<title>${uppercaseFirstLettersInString(HospitalIDMapper.idToStringObject[id])}</title>
<i>Diagnosis</i>
${HospitalIDMapper.idToStringObject[`${id}-DESC`]}

Identified by:
${diagnosisToExamList}

Presents with:
${listStr}
\n\n\n\n    
`;
                            break;
                        case SpecialPageTypes.Exams:
                            HospitalIDMapper.getString("examsToSymptoms", id)
                                .map((e) => ({
                                    id: e,
                                    str: HospitalIDMapper.idToStringObject[e]
                                }))
                                .filter((e) => Boolean(e.str))
                                .sort((a,b) => a.str.localeCompare(b.str))
                                .forEach((e) => {
                                    if(e.str) {
                                        listStr += `<hyperlink url="../../symptoms/${
                                            e.id
                                        }">${e.str}</hyperlink>\n`;
                                    }
                                });

                            this.mainContentsText.text = `
<title>${uppercaseFirstLettersInString(HospitalIDMapper.idToStringObject[id])}</title>
<i>Examination</i>
${HospitalIDMapper.idToStringObject[`${id}-DESC`]}

Identifies:
${listStr}
\n\n\n\n\n\n    
`;
                            break;
                        case SpecialPageTypes.Treatments:
                            HospitalIDMapper.getString("treatmentsToSymptoms", id)
                                .map((e) => ({
                                    id: e,
                                    str: HospitalIDMapper.idToStringObject[e]
                                }))
                                .filter((e) => Boolean(e.str))
                                .sort((a,b) => a.str.localeCompare(b.str))
                                .forEach((e) => {
                                    listStr += `<hyperlink url="../../symptoms/${
                                        e.id
                                    }">${e.str}</hyperlink>\n`;
                                });

                            this.mainContentsText.text = `
<title>${uppercaseFirstLettersInString(HospitalIDMapper.idToStringObject[id])}</title>
<i>Treatment</i>
${HospitalIDMapper.idToStringObject[`${id}-DESC`]}

Treats:
${listStr}
\n\n\n\n    
`;
                            break;
                        default:
                            if(GAME_DEBUG_MODE) {
                                console.log(type);
                                console.log(contents);
                                console.log(this.websiteContentID);
                            }
                            this.mainContentsText.text = WebsiteContents["404"].contents;
                            break;
                    }
                    this.updateHyperlinksInText(this.mainContentsText);
                }
                // this._name = ""
            } else {
                let type: SpecialPageTypes = null;
                // if(SpecialPages[SpecialPageTypes.Symptoms].indexOf(this.websiteContentID) !== -1) {
                //     type = SpecialPageTypes.Symptoms;
                // } else if(SpecialPages[SpecialPageTypes.Exams].indexOf(this.websiteContentID) !== -1) {
                //     type = SpecialPageTypes.Exams;
                // } else if(SpecialPages[SpecialPageTypes.Treatments].indexOf(this.websiteContentID) !== -1) {
                //     type = SpecialPageTypes.Treatments;
                // } else if(SpecialPages[SpecialPageTypes.Diagnoses].indexOf(this.websiteContentID) !== -1) {
                //     type = SpecialPageTypes.Diagnoses;
                // }
                if(
                    this.websiteContentID == SEARCH_HOMEPAGE
                ) {
                    type = SpecialPageTypes.SearchPage;
                }

                if(type == null) {
                    this.mainContentsText.text = contents.contents;
                    contents.onVisit?.();
                    this.updateHyperlinksInText(this.mainContentsText);
                } else if(type === SpecialPageTypes.SearchPage) {

                    if(!Win95InternetExplorerWindow.searchBarPrefabSingleton) {
                        Win95InternetExplorerWindow.searchBarPrefabSingleton = new SearchbarPrefab({
                            width: 400,
                            skipButtons: false,
                            allowFreeInput: true,
                            searchFilterFunction: (e) => (e.score > 1.4),
                            skipPreview: false,
                            onType: () => {}
                        });
                        Win95InternetExplorerWindow.searchBarPrefabSingleton.position.set(
                            tsthreeConfig.width * 0.5,
                            240
                        );
                    }

                    this.mainContentsText.text = contents.contents;
                    contents.onVisit?.();
                    this.updateHyperlinksInText(this.mainContentsText);

                    Win95InternetExplorerWindow.searchBarPrefabSingleton.updateSearch(
                        (_results) => {
                            if(!_results || !_results.length) return;
                            Win95InternetExplorerWindow.searchBarPrefabSingleton.hide();

                            if(_results.length === 0 || !_results[0].type) {
                                this.changePage(
                                    `${SEARCH_HOMEPAGE}/search?query=${
                                        _results[0].name
                                            .replace(/ /g, "+")
                                    }`
                                );
                            } else {
                                // alert(JSON.stringify(_results[0]));
                                this.changePage(
                                    // @ts-ignore
                                    `${SEARCH_HOMEPAGE}/${_results[0].type}/${_results[0].id}`
                                );
                            }

                            // Win95InternetExplorerWindow.searchBarPrefabSingleton.hide();
                            // this.mainContentsText.text += "\n\n\n\n";
                            // e.forEach((e) => {
                            //     this.mainContentsText.text += `<hyperlink url="/${e.id}">${e.name}</hyperlink>` + "\n";
                            // });
                            // this.updateHyperlinksInText(this.mainContentsText);
                            // this.scrollBar.update(Math.ceil(
                            //     Math.max(
                            //         this.mainContentsContainer.height - this.mainContentsBg.height,
                            //         0
                            //     ) / 16
                            // ));
                        },
                        () => {
                            if(!Win95InternetExplorerWindow.searchBarPrefabSingleton.currentText) return;
                            const results = SearchbarPrefab.getMinisearchCache().search(
                                Win95InternetExplorerWindow.searchBarPrefabSingleton.currentText
                            );
                            if(results.length > 0) {
                                this.changePage(
                                    `${SEARCH_HOMEPAGE}/${results[0].type}/${results[0].id}`
                                );
                            }
                        }
                    );

                    Win95InternetExplorerWindow.searchBarPrefabSingleton.show(this.mainContentsText.parent);
                }
            }

            const maxIncrements = Math.ceil(
                Math.max(
                    this.mainContentsContainer.height - this.mainContentsBg.height,
                    0
                ) / 16
            );
            this.scrollBar.update(
                maxIncrements
            );
            document.body.style.cursor = "auto";
            this.isChangingPage = false;
        }, 200);
    }

    constructor(_settings: {
        onMinimise?: () => void,
        onClose?: () => void,
        windowStateRef: IWindowState<Win95InternetExplorerWindow>,
    }) {
        super({
            title: "Internet Traveller",
            iconKey: "iexplorer-page-icon",
            windowStateRef: _settings.windowStateRef,
            onMinimise: () => {
                if(_settings.onMinimise) {
                    _settings.onMinimise();
                }
            },
            onClose: () => {
                if(_settings.onClose) {
                    _settings.onClose();
                }
            }
        });
        this.initializeImageTags();

        // TDG-55
        taggedTextStyleMap["default"].wordWrapWidth
            = tsthreeConfig.width - 50;
        if(Win95InternetExplorerWindow.searchBarPrefabSingleton) {
            Win95InternetExplorerWindow.searchBarPrefabSingleton.position.set(
                tsthreeConfig.width * 0.5,
                240
            );
        }

        const fileEditViewText = new FileEditHelpBar([
            {
                name: "File",
                subcontents: [
                    {
                        name: "Exit",
                        onClick: () => {
                            this._onClose();
                        }
                    }
                ]
            },
            {
                name: "Edit",
                subcontents: [
                    {
                        name: "Copy URL",
                        onClick: () => {
                            navigator.clipboard.writeText(
                                this.urlSearchBar.currentText
                            );
                        }
                    },
                ]
            },
        ]);
        fileEditViewText.position.set(6, 5);
        this.contentContainer.addChild(fileEditViewText);

        const backForwardBg = new NineSlicePlane(ENGINE.getPIXIResource("generic-container-nineslice") as Texture);
        backForwardBg.width = tsthreeConfig.width;
        backForwardBg.height = 43;
        backForwardBg.position.set(0, 22);
        this.contentContainer.addChild(backForwardBg);

        const backButtonContainer = new Container();
        const backButtonIcon = new Sprite(ENGINE.getPIXIResource("back-button") as Texture);
        backButtonIcon.anchor.set(1, 1);
        backButtonIcon.position.set(-4, -2);
        backButtonContainer.addChild(backButtonIcon);
        const backButtonText = new Text("Back", new TextStyle({
            fontFamily: GAME_FONT,
            align: "right",
            fontSize: 11,
        }));
        backButtonText.anchor.set(1, 0);
        backButtonText.position.set();
        backButtonContainer.addChild(backButtonText);
        backButtonContainer.position.set(55, 27);
        buttonify(backButtonContainer, {
            onFire: () => {
                if(this.breadcrumbIndex === 0 || this.breadcrumbTrail.length == 0) {
                    return;
                }
                this.breadcrumbIndex -= 1;
                this.changePage(this.breadcrumbTrail[this.breadcrumbIndex], true);

                // not sure why this happens twice, my brain refuses to get it
                // this.breadcrumbTrail.pop();
                // this.breadcrumbTrail.pop();
            }
        });
        backForwardBg.addChild(backButtonContainer);

        const forwardButtonContainer = new Container();
        const forwardButtonIcon = new Sprite(ENGINE.getPIXIResource("forward-button") as Texture);
        forwardButtonIcon.anchor.set(1, 1);
        forwardButtonIcon.position.set(-4, -2);
        forwardButtonContainer.addChild(forwardButtonIcon);
        const forwardButtonText = new Text("Forward", new TextStyle({
            fontFamily: GAME_FONT,
            align: "left",
            fontSize: 11,
        }));
        forwardButtonText.anchor.set(1, 0);
        forwardButtonText.position.set();
        forwardButtonContainer.addChild(forwardButtonText);
        forwardButtonContainer.position.set(135, 27);
        buttonify(forwardButtonContainer, {
            onFire: () => {
                if(this.breadcrumbTrail.length === 0 || this.breadcrumbIndex >= this.breadcrumbTrail.length - 1) {
                    return;
                }
                console.log(this.breadcrumbTrail);
                console.log(this.breadcrumbTrail[this.breadcrumbIndex]);
                this.breadcrumbIndex += 1;
                console.log(this.breadcrumbTrail[this.breadcrumbIndex]);
                this.changePage(this.breadcrumbTrail[this.breadcrumbIndex], true);
            }
        });
        backForwardBg.addChild(forwardButtonContainer);

        const homeButtonContainer = new GameObject();
        homeButtonContainer.addComponent(
            new TutorialStageComponent({
                id: "HomeButtonStage"
            })
        );
        const homeButtonIcon = new Sprite(
            ENGINE.getPIXIResource("home-button") as Texture
        );
        homeButtonIcon.anchor.set(0.5);
        homeButtonIcon.position.set(0, -2);
        homeButtonContainer.addChild(homeButtonIcon);
        const homeButtonText = new Text("Home", new TextStyle({
            fontFamily: GAME_FONT,
            align: "left",
            fontSize: 11,
        }));
        homeButtonText.anchor.set(0.5, 0);
        homeButtonText.position.set(0, 9);
        homeButtonContainer.addChild(homeButtonText);
        buttonify(homeButtonContainer, {
            onFire: () => {
                this.changePage(SEARCH_HOMEPAGE);
                homeButtonContainer.getComponent(TutorialStageComponent)?.onActivate?.();
            }
        });
        homeButtonContainer.position.set(195, 18);
        backForwardBg.addChild(homeButtonContainer);

        const urlAreaBg = new NineSlicePlane(ENGINE.getPIXIResource("generic-container-nineslice") as Texture);
        urlAreaBg.width = tsthreeConfig.width;
        urlAreaBg.height = 30;
        urlAreaBg.position.set(0, 64);
        this.contentContainer.addChild(urlAreaBg);

        // const urlBarBg = new NineSlicePlane(
        //     ENGINE.getPIXIResource("inner-container-nineslice") as Texture
        // );
        // urlBarBg.width = tsthreeConfig.width - 2 - 55;
        // urlBarBg.height = 22;
        // urlBarBg.position.set(55, 68);
        // this.contentContainer.addChild(urlBarBg);
        const urlAddressText = new Text("Address", new TextStyle({
            fontFamily: GAME_FONT,
            fill: 0x000000,
            fontSize: 11,
            align: "left",
        }));
        urlAddressText.position.set(
            10, 72
        );
        this.contentContainer.addChild(urlAddressText);

        const urlSearchBar = this.urlSearchBar = new SearchbarPrefab({
            width: tsthreeConfig.width - 2 - 55 - 16,
            height: 22,
            prefix: true,
            fuzzy: 0.2,
            skipButtons: true,
            allowFreeInput: true,
            minisearchKey: "urls",
            onType: () => {},
            searchFilterFunction: (e) => (e.score > 2.4),
            skipPreview: false,
        });
        urlSearchBar.updateSearch((e) => {
            if(GAME_DEBUG_MODE)
                console.log(`Search results: %o`, e);
            this.changePage(
                e[0]?.name as TWebsiteContentID,
            );
        }, () => {});
        urlSearchBar.textOffset = 17;
        this.contentContainer.addChild(urlSearchBar);
        // const urlText = this.urlText = new Text(this.websiteContentID, urlAddressText.style);
        urlSearchBar.position.set(
            ((tsthreeConfig.width - 2 - 55 - 16) / 2) + 60, 69
        );

        const urlIcon = new Sprite(this.icon);
        urlIcon.position.set(-(urlSearchBar.position.x - 63), 3);
        urlSearchBar.addChild(urlIcon);
        // urlBarBg.addChild(urlText);

        const mainContentsContainer = this.mainContentsContainer = new GameObject();
        mainContentsContainer.addComponent(new TutorialStageComponent({
            id: "WebpageStage"
        }));
        const contentsMask = new Graphics();
        contentsMask.beginFill(0xff0000);
        contentsMask.drawRect(0, 2, tsthreeConfig.width, tsthreeConfig.height - 166);
        contentsMask.endFill();
        mainContentsContainer.mask = contentsMask;
        mainContentsContainer.addChild(contentsMask);

        const mainContentsContainerBg = this.mainContentsBg = new NineSlicePlane(
            ENGINE.getPIXIResource("inner-container-nineslice") as Texture
        );
        mainContentsContainerBg.width = tsthreeConfig.width;
        mainContentsContainerBg.height = tsthreeConfig.height - 158;
        mainContentsContainer.addChild(mainContentsContainerBg);
        this.contentContainer.addChild(mainContentsContainer);
        mainContentsContainer.position.set(0, 93);

        const mainContentsText = this.mainContentsText = new TaggedText(
            "",
            taggedTextStyleMap,
            {
                imgMap: {
                    "drugle": ENGINE.getPIXIResource("drugle-logo") as Texture
                }
            }
        );
        this.mainContentsText.position.set(20, 0);
        // this.updateHyperlinksInText(mainContentsText);

        mainContentsContainer.addChild(mainContentsText);

        const mainContentsScrollbar = this.scrollBar = new ScrollBar({
            height: tsthreeConfig.height - 170,
            onScroll: (_currIncrements: number) => {
                this.mainContentsText.position.set(
                    this.mainContentsText.position.x,
                    _currIncrements * -16
                );
            }
        });
        mainContentsScrollbar.position.set(tsthreeConfig.width - 2, 95);
        this.contentContainer.addChild(mainContentsScrollbar);

        const urlPreview = this.urlBarText = new Text("", new TextStyle({
            fontFamily: GAME_FONT,
            fontSize: 11,
            fill: 0x000000,
        }));
        urlPreview.position.set(4, this.contentContainer.height + 10);
        this.contentContainer.addChild(urlPreview);

        document.addEventListener("wheel", (ev) => {
            if(!this.visible) return;
            this.scrollBar.scrollWheel((ev.deltaY / 100));
        });

        bringToFront(urlSearchBar);
        bringToFront(fileEditViewText);
    }

    private updateHyperlinksInText(_target: TaggedText): void {
        _target.textFields.forEach((e) => {
            // @ts-ignore
            if(e.style?.url) {
                // @ts-ignore
                const targetUrl: string = e.style?.url;
                buttonify(e, {
                    onFire: () => {
                        if(this.mainContentsContainer.getComponent(TutorialStageComponent)?.isActive) {
                            return;
                        }

                        const currUrl = this.websiteContentID;

                        try {
                            if(targetUrl.indexOf("/") == 0) {
                                this.changePage(
                                    this.websiteContentID + targetUrl);
                            } else if(targetUrl.indexOf("../") == 0) {
                                let decrements = 0;
                                targetUrl.split("/").forEach((e) => e == ".." ? decrements++ : undefined);
                                const splitUrl = currUrl.split("/");
                                const pageUp = splitUrl.slice(0, splitUrl.length - decrements);
                                const contentId = pageUp.join("/") + "/" + targetUrl.split("/").slice(decrements).join("/");
                                this.changePage(
                                    contentId
                                );
                            } else {
                                this.changePage(targetUrl);
                            }
                        } catch(err) {
                            ShowBluescreen(err.stack);
                        }
                    },
                    onPointerOver: () => {
                        this.urlBarText.text =
                            // @ts-ignore
                            e.style.url;
                    },
                    onPointerOut: () => {
                        this.urlBarText.text = "";
                    }
                });
            }
        });
    }

    public onStep(_dt: number) {
        super.onStep(_dt);
    }

}